// extracted by mini-css-extract-plugin
export default {"chip":"Chip_chip__ox+P-","text":"Chip_text__g1xkc"};